import { IconListItemA } from '../classes/IconListItem';
import { BaseCategory, baseCategoryToJSON } from '@enrollhere/classes';
import {
  faHospital,
  faHeartPulse,
  faKitMedical,
  faMoneyBillTrendUp,
  faShieldHeart,
} from '@fortawesome/pro-regular-svg-icons';
import { TagsFilterItem } from '../components/filters/signals/tags-filter/tags-filter.component';

export const baseCategoryMap: { [key: number]: Partial<IconListItemA> } = {
  [BaseCategory.BC_MEDICARE]: {
    title: 'Medicare',
    icon: faHeartPulse,
  },
  [BaseCategory.BC_ANNUITY]: {
    title: 'Annuity',
    icon: faMoneyBillTrendUp,
  },
  [BaseCategory.BC_HEALTH]: {
    title: 'Health',
    icon: faHospital,
  },
  [BaseCategory.BC_LIFE]: {
    title: 'Life',
    icon: faShieldHeart,
  },
  [BaseCategory.BC_ANCILLARY]: {
    title: 'Ancillary',
    icon: faKitMedical,
  },
};

const baseCategoryFilterOrder: BaseCategory[] = [
  BaseCategory.BC_MEDICARE,
  BaseCategory.BC_LIFE,
  BaseCategory.BC_HEALTH,
  BaseCategory.BC_ANNUITY,
  BaseCategory.BC_ANCILLARY,
];

export function getBaseCategoryFilterOptions(): TagsFilterItem[] {
  return baseCategoryFilterOrder.map(cat => {
    const meta = baseCategoryMap[cat];
    return {
      id: baseCategoryToJSON(cat),
      label: meta?.title ?? baseCategoryToJSON(cat),
      icon: meta?.icon,
    };
  });
}
